import { useCallback, useMemo, useState } from "react";

import { SiteDashboard } from "~/api/Api";

import { RenameDashboardModal } from "./RenameDashboardModal";

type UseRenameDashboardModal = {
  dashboard: SiteDashboard;
  updateName: (name: string) => Promise<void>;
};

export const useRenameDashboard = ({
  dashboard,
  updateName,
}: UseRenameDashboardModal) => {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const onRename = () => {
    setIsModalOpen(true);
  };

  const handleClose = useCallback(() => {
    setIsModalOpen(false);
  }, [setIsModalOpen]);

  const ConnectedRenameModal = useMemo(
    () => () => (
      <RenameDashboardModal
        isOpen={isModalOpen}
        onClose={handleClose}
        dashboard={dashboard}
        updateName={updateName}
      />
    ),
    [isModalOpen, handleClose, dashboard, updateName],
  );

  return {
    onRename,
    RenameModal: ConnectedRenameModal,
  };
};
